<header class="flex justify-between items-center mb-4">
  @if (batchId) {
  <div class="flex flex-row items-center justify-start space-x-2">
    <app-button variant="secondary" routerLink="../../batch-list" queryParamsHandling="merge" customClass="mr-4">
      {{ 'CREATE_BATCH.HEADER.BACK' | translate }}
    </app-button>
    <h2>{{ 'CREATE_BATCH.HEADER.BATCH_DETAILS' | translate }}</h2>
  </div>
  } @else {
  <app-button variant="secondary" routerLink="../batch-list" queryParamsHandling="merge" customClass="mr-4">
    {{ 'CREATE_BATCH.HEADER.BACK' | translate }}
  </app-button>
  } @if(batchId){
  <div class="flex flex-row space-x-2">
    <button type="button" [ngClass]="{
  'px-4 py-2 flex items-center space-x-2 rounded-lg font-semibold shadow-sm': true,
  'bg-secondary text-white shadow-sm cursor-not-allowed': isReplayDisabled(),
  'bg-primary text-white': !isReplayDisabled()
  }" (click)="replayReconciliationBatch()" [disabled]="isReplayDisabled()">
      <p class="text-white">
        {{ 'CREATE_BATCH.HEADER.RELAUNCH' | translate }}
      </p>
      <div class="w-6 h-6 flex items-center justify-center rounded-md">
        <div>
          @if (isSaving()) {
          <app-loading-spinner></app-loading-spinner>
          <span class="sr-only">Loading...</span>

          }@else {
          <img src="../../../assets/replay.png" alt="Replay Icon" class="w-5 h-5" />
          }
        </div>
      </div>
    </button>
    <div class="flex items-center justify-center">
      <app-dropdown [optionItems]="optionItems()">
        <app-icon-more-actions size="size-6" strokeWidth="1.5"></app-icon-more-actions>
      </app-dropdown>
    </div>
  </div>
  }
</header>
<div class="content-card p-6">
  <form [formGroup]="batchForm" (ngSubmit)="onSubmit()">
    <div class="flex flex-row space-x-4">
      <div class="w-1/2">
        <app-input
          id="name"
          [label]="'CREATE_BATCH.BODY.NAME' | translate"
          formControlName="name"
          [placeholder]="'CREATE_BATCH.BODY.NAME' | translate"
          [error]="batchForm.get('name')?.invalid && batchForm.get('name')?.touched ? ('CREATE_BATCH.BODY.NAME_REQUIRED' | translate) : null"
          [reserveErrorSpace]="false"
          *appSkeleton="loadingOpTypes()"
        ></app-input>
      </div>

      <div class="w-1/2">
        <app-select
          id="typeOp"
          variant="form"
          [label]="'CREATE_BATCH.BODY.TYPE_OF_OPERATION' | translate"
          [placeholder]="'CREATE_BATCH.BODY.TYPE_OF_OPERATION' | translate"
          formControlName="operationType"
          [items]="operationTypeItems"
          bindLabel="name"
          bindValue="code"
          [searchable]="true"
          [allowDeselect]="false"
          [reserveErrorSpace]="false"
          *appSkeleton="loadingOpTypes()"
        ></app-select>
      </div>
    </div>
    <div class="w-full my-4">
      <div class="flex flex-col space-y-2">
        @if(!batchId) {
        @if (batchForm.get('operationType')?.valid) {
        <div class="flex space-x-4">
          <div class="w-1/2 flex items-center" [class]="isExtractingInternal? 'opacity-70 cursor-not-allowed' : ''">
            <input type="file" (change)="onFileSelected($event, 0)" class="hidden" id="boFileInput" multiple />
            @if (isExtractingInternal) {
            <span class="bg-gray-300 px-3 py-2 rounded flex items-center gap-2 text-gray-700 opacity-70">
              <app-loading-spinner class="w-5 h-5"></app-loading-spinner>
              {{ 'CREATE_BATCH.BODY.EXTRACTING_FILES' | translate }}
            </span>
            } @else {
            <label for="boFileInput" class="bg-gray-300 px-3 py-2 rounded cursor-pointer"
              *appSkeleton="!listOperationTypes || (showSourceTypesBundle() && sourceTypesBundleLoading()); theme: {'height': '40px', 'width': '220px', 'border-radius': '0.25rem', 'margin-bottom': '0' }">{{
              'CREATE_BATCH.BODY.LOAD_INTENAL_FILES' | translate }}
            </label>
            }
          </div>
          @if (loading) {
          <div class="w-1/2 flex items-center space-x-2">
            <div class="w-1/2 bg-gray-200 rounded-full h-2">
              <div class="bg-primary-800 h-2 rounded-full transition-all" [style.width.%]="uploadProgress"></div>
            </div>
            @if (uploadProgress > 0 && uploadProgress < 100) { <p class="text-sm">{{ uploadProgress }}%</p>
              }
          </div>
          }
        </div>
        }
        }
        @else {
        @if(isBankReconciliation()){
        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          @for (source of internalSourcePaths; track source) {
          <app-folder-files [folderName]="source.sourceTypeName" [filePaths]="source.paths"></app-folder-files>
          }
        </div>
        }@else {
        <!-- Show internalSourcePaths Classic after save-->
        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4"
          *appSkeleton="showBatchDetails; theme: {'height': '40px', 'width': '220px', 'border-radius': '0.25rem', 'margin-bottom': '0' }">
          <app-folder-files [folderName]="'CREATE_BATCH.BODY.INTERNAL_SOURCE' | translate"
            [filePaths]="classicSourcePaths"></app-folder-files>
        </div>
        }
        }
      </div>
    </div>
    @if (showSourceTypesBundle()) {
    <div class="flex flex-col space-y-4 w-full ml-2 mb-8" *appSkeleton="sourceTypesBundleLoading()">
      @for(item of sourceTypesBundle(); track item.id) {
      <div class="grid grid-cols-4 gap-2 items-center p-2 border-b-[1px] transition-colors duration-200"
        [ngClass]="{'border-red-500 border-2 bg-red-50 rounded-lg px-2': item.error}">
        <div class="flex flex-col col-span-1">
          <span class="text-gray-700">{{ item.name }}</span>
          @if (item.error) {
          <span class="text-red-700 text-xs font-semibold mt-1">
            <i class="fa-solid fa-triangle-exclamation mr-1"></i>{{ item.error }}
          </span>
          }
        </div>
        @if (uploadedFilesBySourceType[item.code]) {
        <div class="flex items-center col-span-3 w-full">
          <div class="flex-grow flex items-center space-x-4">
            <div class="flex-shrink-0">
              {{ uploadedFilesBySourceType[item.code].length }} {{'BATCH_LINE.FILES' | translate}}
            </div>
            @if (showFilesBySourceType()[item.code]) {
            <div class="flex flex-wrap gap-x-2">
              @for(file of uploadedFilesBySourceType[item.code]; track file.name) {
              <app-display-file [filename]="file.name" [creation]="true"
                (remove)="removeSourceBankFile(item.code, $event)"></app-display-file>
              }
            </div>
            }
          </div>
          <div class="flex-shrink-0">
            <button type="button" (click)="onShowFiles(item.code)"
              class="badge badge--secondary flex items-center p-2 h-8">
              <i class="fa-sharp-duotone fa-thin fa-eye"></i>
            </button>
          </div>
        </div>
        }
      </div>
      }
    </div>
    }
    <!-- List of Internal classic Files -->
    @if(!batchId && batchForm.get('operationType')?.value && !isBankReconciliation()) {
    <div class="flex flex-col space-y-4 w-full ml-2 mb-8">
      <div class="grid grid-cols-4 gap-2 items-center p-2 border-b-[1px] transition-colors duration-200">
        <div class="flex flex-col col-span-1">
          <span class="text-gray-700">{{ 'CREATE_BATCH.BODY.INTERNAL_SOURCE' | translate }}</span>
        </div>
        @if (internalSourceTypeFile) {
        <div class="flex items-center col-span-3 w-full">
          <div class="flex-grow flex items-center space-x-4">
            <div class="flex-shrink-0">
              {{ internalSourceTypeFile.length }} {{'BATCH_LINE.FILES' | translate}}
            </div>
            @if (showInternalSourceFiles()) {
            <div class="flex flex-wrap gap-x-2">
              @for(file of internalSourceTypeFile; track file.name) {
              <app-display-file [filename]="file.name" [creation]="true"
                (remove)="removeInternalFile($event)"></app-display-file>
              }
            </div>
            }
          </div>
          <div class="flex-shrink-0">
            <button type="button" (click)="onShowInternalSourceFiles()"
              class="badge badge--secondary flex items-center p-2 h-8">
              <i class="fa-sharp-duotone fa-thin fa-eye"></i>
            </button>
          </div>
        </div>
        }
      </div>
    </div>
    }
    @if (batchId) {
    <div class="py-4 flex flex-row items-center justify-between" *appSkeleton="showBatchDetails">
      <div class="flex items-center" [class]="isExtractingExternal? 'opacity-70 cursor-not-allowed' : ''">
        <input type="file" multiple class="hidden cursor-not-allowed" id="fileInput"
          (change)="onFileSelected($event, 1)" [disabled]="isReconciling()" />
        @if (isExtractingExternal) {
        <span class="bg-gray-300 py-2 px-4 rounded flex items-center gap-2 text-gray-700 opacity-70">
          <app-loading-spinner class="w-5 h-5"></app-loading-spinner>
          {{ 'CREATE_BATCH.BODY.EXTRACTING_FILES' | translate }}
        </span>
        } @else {
        <label for="fileInput" class="bg-gray-300 py-2 px-4 rounded "
          [class]="isReconciling()? 'cursor-not-allowed opacity-50':  'cursor-pointer'">
          {{ 'CREATE_BATCH.BODY.LOAD_EXTERNAL_FILES' | translate }}
        </label>
        }
      </div>
      <div class="flex items-center gap-2">
        @if(canReplayReconciliations()){
        <button type="button" (click)="replayBundle()" class="button" [disabled]="isReconciling()"
          [class]="isReconciling()? 'cursor-not-allowed opacity-50':  'cursor-pointer'">{{
          'CREATE_BATCH.BODY.REPLAY_RECONCILIATIONS' | translate }}</button>
        }
        <div class="p-2 bg-stone-100 rounded">
          {{ numberReconciliation() }}/{{ numberSourceType() }} {{ 'CREATE_BATCH.BODY.RECONCILIATIONS' | translate }}
        </div>
      </div>

    </div>
    }
    @if (!batchId) {
    <app-button
      type="submit"
      [loading]="isSaving()"
      [disabled]="batchForm.invalid"
    >
      {{ 'CREATE_BATCH.BODY.CREATE' | translate }}
    </app-button>
    }
  </form>
  <span class="text-red-700 p-1 text-sm mt-2 block rounded">{{error}}</span>
  @if (batchId) {
  <div class="py-2" *appSkeleton="showBatchDetails">
    @for (reconciliation of reconciliations(); track reconciliation) {
    <app-batch-line [reconciliation]="reconciliation" [batchId]="batchId"
      [isBankReconciliation]="isBankReconciliation()" [isReconciling]="isReconciling()"
      (newReconciliation)="updateReconciliations($event)" (relauchReconciliation)="updateRelauchReconciliations($event)"
      (reconciliationStatusChanged)="handleReconciliationStatusChange($event)"
      [(selectedCustomer)]="selectedCustomer"></app-batch-line>
    }
  </div>
  }
  <!-- @if (batchId) {
  <div class="mt-2">
    <button type="button" class="button">{{ 'CREATE_BATCH.BODY.SUBMIT' | translate }}</button>
  </div>
  } -->
</div>

<!-- Edit Transactions Modal -->
<app-edit-transactions-modal [isOpen]="showEditModal" [batchId]="batchId" [loading]="loading" [customerId]="customerId"
  [manualFieldsOverrides]="manualFieldsOverrides" (close)="closeEditModal()"
  (editTransactions)="editTransactionsModal()" [results]="results" [editableBundleFields]="editableBundleFields()">
</app-edit-transactions-modal>